import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import {
  DossierTransactionPaginationList,
  DossierTransactionType,
} from "../../types/DossierTransaction";
import { PaginationFilters } from "../../types/Pagination";

export type DossierBudgetTransactionFilters = PaginationFilters & {
  dossierId: string;
  transactionType: DossierTransactionType;
  includeInvoiced: boolean;
  includeSpent: boolean;
  dateFrom?: string;
  dateTo?: string;
};

export const getDossierBudgetTransactions = (
  filters: DossierBudgetTransactionFilters,
  options: APQueryOptions = {}
) => {
  const {
    nextPageLink,
    pageSize,
    includeInvoiced,
    includeSpent,
    ...otherFilters
  } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierBudgetTransactions", filters],
    queryFn: (): Promise<DossierTransactionPaginationList> => {
      return fetchWithAuth<DossierTransactionPaginationList>(
        "getDossierBudgetTransactions",
        filters.dossierId,
        {
          queryParams: {
            ...otherFilters,
            includeInvoiced: `${includeInvoiced}`,
            includeSpent: `${includeSpent}`,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
